import { render, staticRenderFns } from "./PressArticle.vue?vue&type=template&id=80363834&scoped=true&"
import script from "./PressArticle.vue?vue&type=script&lang=js&"
export * from "./PressArticle.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "80363834",
  null
  
)

export default component.exports